<div class="touchpoint-notification-snackbar__content">
  <mat-icon class="touchpoint-notification-snackbar__icon">notifications</mat-icon>
  <div class="touchpoint-notification-snackbar__label" matSnackBarLabel>
    @for (item of data.items; track item) {
      <div class="touchpoint-notification-snackbar__item">
        <span class="touchpoint-notification-snackbar__message">{{ item.message }}</span>
        <button type="button" class="touchpoint-notification-snackbar__action" (click)="open(item.notification)">{{ data.actionLabel }}</button>
      </div>
    }
  </div>
  <div class="touchpoint-notification-snackbar__actions" matSnackBarActions>
    <button type="button" class="touchpoint-notification-snackbar__close" mat-icon-button aria-label="Dismiss notifications" (click)="dismiss()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
